import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ec0ca91")

_pushScopeId("data-v-0ec0ca91")
const _hoisted_1 = { class: "comment" }
const _hoisted_2 = {
  key: 0,
  class: "icon",
  src: "https://static.soyoung.com/sy-pre/202004031-1585897801571.png"
}
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: "https://static.soyoung.com/sy-pre/lark20201225-111308-1608865800705.png" }, null, -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "img" }
const _hoisted_8 = { class: "create_date_str" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = {
  key: 1,
  class: "zanimg",
  src: "https://static.soyoung.com/sy-pre/1sqkgv4i0hab7-1608711000699.png"
}
const _hoisted_11 = { class: "ding_cnt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editor = _resolveComponent("editor")
  const _component_commentSecond = _resolveComponent("commentSecond")
  const _component_swiper = _resolveComponent("swiper")
  const _component_toast = _resolveComponent("toast")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commentList, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "list"
      }, [
        _createVNode("div", {
          class: "avatar",
          "data-uid": item.uid,
          "data-certified_type": item.certified_type,
          "data-certified_id": item.certified_id,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gohome && _ctx.gohome(...args)))
        }, [
          _createVNode("img", {
            src: item.avatar.u
          }, null, 8, ["src"]),
          (item.certified_type == 1 || item.certified_type == 10 || item.certified_type == 11 || item.certified_type == 14)
            ? (_openBlock(), _createBlock("img", _hoisted_2))
            : _createCommentVNode("", true)
        ], 8, ["data-uid", "data-certified_type", "data-certified_id"]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", {
            class: "user_name",
            "data-uid": item.uid,
            "data-certified_type": item.certified_type,
            "data-certified_id": item.certified_id,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gohome && _ctx.gohome(...args)))
          }, [
            _createTextVNode(_toDisplayString(item.user_name), 1),
            (item.post_author == 1)
              ? (_openBlock(), _createBlock("span", _hoisted_4, [
                  _hoisted_5
                ]))
              : _createCommentVNode("", true)
          ], 8, ["data-uid", "data-certified_type", "data-certified_id"]),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.content, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (item.ident === 'lntext')
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      innerHTML: item.t
                    }, null, 8, ["innerHTML"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.content, (itemname, i) => {
                return (_openBlock(), _createBlock(_Fragment, null, [
                  (itemname.ident === 'lnimage')
                    ? (_openBlock(), _createBlock("img", {
                        src: itemname.u,
                        key: i,
                        "data-i": i,
                        "data-index": index,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shoImg && _ctx.shoImg(...args)))
                      }, null, 8, ["src", "data-i", "data-index"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ]),
          _createVNode("div", _hoisted_8, _toDisplayString(item.create_date_str || '刚刚'), 1),
          (_ctx.pingIndex == index)
            ? (_openBlock(), _createBlock(_component_editor, {
                key: 0,
                csrf: _ctx.csrf,
                post_id: _ctx.post_id,
                reply_id: _ctx.reply_id,
                onGetupdate: _ctx.getupdate
              }, null, 8, ["csrf", "post_id", "reply_id", "onGetupdate"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_9, [
            (_ctx.uid == item.uid)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "del",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.del && _ctx.del(...args))),
                  "data-reply_id": item.reply_id
                }, null, 8, ["data-reply_id"]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "pinglun",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showPinglun && _ctx.showPinglun(...args))),
              "data-index": index,
              "data-reply_id": item.reply_id
            }, null, 8, ["data-index", "data-reply_id"]),
            (item.is_favor == 1)
              ? (_openBlock(), _createBlock("img", _hoisted_10))
              : (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "zan",
                  "data-index": index,
                  "data-reply_id": item.reply_id,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.zan && _ctx.zan(...args)))
                }, null, 8, ["data-index", "data-reply_id"])),
            _createVNode("div", _hoisted_11, _toDisplayString(item.ding_cnt), 1)
          ]),
          (item.comment)
            ? (_openBlock(), _createBlock(_component_commentSecond, {
                key: 1,
                index: index,
                comment: item.comment,
                post_id: _ctx.post_id,
                comment_cnt: parseInt(item.comment_cnt)
              }, null, 8, ["index", "comment", "post_id", "comment_cnt"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    (_ctx.imglist.length > 0)
      ? (_openBlock(), _createBlock(_component_swiper, {
          key: 0,
          img: _ctx.imglist,
          index: _ctx.imglistindex,
          onClose: _ctx.close
        }, null, 8, ["img", "index", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ]))
})